import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Switch } from "@headlessui/react";
import back from "../../Assets/Image/admin/back.png";
import FormSelect from "../../Base-Component/FormSelect/FormSelect";
import add from "../../Assets/Image/admin/add.png";
import Dialog from "../../Base-Component/Dialog/Dialog";
import close from "../../Assets/Image/admin/close.png";
import {
  ChevronDown,
  ChevronUp,
  CircleX,
  Eye,
  PenLine,
  Trash2,
  Upload,
  GripVertical,
  Ban,
  CircleOff,
} from "lucide-react";
import { Bars, Circles } from "react-loader-spinner";
import {
  addSubcategory,
  deleteSubcategory,
  getSubcategoryList,
  listUserRole,
  updateSubcategory,
  getCategoryList,
  changeSubcategoryStatus,
} from "../../Services/ApiServices";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import nodata from "../../Assets/Image/admin/nodata.png";
import { IMG_URL, LIST_LANGUAGES_API } from "../../Services/Api";
import noImage from "../../Assets/Image/admin/user.png";
import axios from "axios";
import "suneditor/dist/css/suneditor.min.css";
import SunEditor from "suneditor-react";
import DOMPurify from "dompurify";
import PropTypes from "prop-types";
import Cropper from "react-easy-crop";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  rectSortingStrategy,
  useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const SortableSubcategoryItem = ({
  item,
  index,
  selectStatus,
  roleData,
  handleView,
  handleEditView,
  handleEdit,
  handleBlock,
  IMG_URL,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
    zIndex: isDragging ? 50 : "auto",
  };

  const image = item?.Sub_category_images;
  const blocked = item.isBlock === 1 || item.isBlock === true || item.isBlock === '1' || item.status === 0 || item.status === '0' || item.isActive === false || item.isActive === 0 || item.isActive === '0';

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="2xl:col-span-3 xl:col-span-4 sm:col-span-6 col-span-12 cursor-pointer hover:drop-shadow-md duration-200 flex justify-center bg-white rounded-xl relative group"
    >
      <div className="w-full relative">
        {/* Position Number Badge */}
        {selectStatus !== "all" && (
          <div className="absolute top-3 left-3 bg-white/95 backdrop-blur-sm border border-gray-150 text-gray-800 text-[12px] font-bold w-7 h-7 rounded-full flex items-center justify-center shadow-md z-20 select-none">
            {item.position_number || index + 1}
          </div>
        )}

        {/* Drag Handle & Actions */}
        <div className="p-4">
          <div className="flex justify-end absolute top-3 right-3 z-20 gap-2" onPointerDown={(e) => e.stopPropagation()} onClick={(e) => e.stopPropagation()}>
            {roleData?.role !== "sub_admin" && selectStatus !== "all" && (
              <div
                className="bg-white w-[32px] h-[32px] flex items-center justify-center rounded-full cursor-grab active:cursor-grabbing shadow-md border border-gray-150 hover:bg-gray-50 transition-colors"
                {...attributes}
                {...listeners}
                title="Drag to reorder"
              >
                <GripVertical className="w-5 h-5 text-gray-500" />
              </div>
            )}
          </div>

          <img
            src={
              image && image[0]?.subcategory_image
                ? IMG_URL + image[0]?.subcategory_image
                : ""
            }
            className="rounded-[15px] w-full md:h-[350px] h-[300px] object-cover"
            alt=""
          />
          <div className="mt-3 flex flex-col font-semibold">
            <h4 className="text-left text-gray-800">{item.title || "-"}</h4>
            <div className="flex justify-end items-center gap-2 mt-1.5" onPointerDown={(e) => e.stopPropagation()} onClick={(e) => e.stopPropagation()}>
              <span className={`px-2.5 py-0.5 rounded-full text-xs font-semibold shadow-sm border ${blocked ? 'bg-red-50 text-red-600 border-red-200' : 'bg-green-50 text-green-600 border-green-200'
                }`}>
                {blocked ? 'Inactive' : 'Active'}
              </span>
              {roleData?.role !== "sub_admin" && (
                <Switch
                  checked={!blocked}
                  onChange={() => handleBlock(item, index)}
                  className="group relative flex h-6 w-11 cursor-pointer rounded-full bg-gray-300 p-0.5 transition-colors duration-200 ease-in-out focus:outline-none data-[focus]:outline-1 data-[focus]:outline-white data-[checked]:bg-[#e29c29]"
                >
                  <span
                    aria-hidden="true"
                    className="pointer-events-none inline-block size-5 translate-x-0 rounded-full bg-white ring-0 shadow-lg transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                  />
                </Switch>
              )}
            </div>
          </div>
        </div>

        <div className="border-t flex justify-between p-3 font-medium text-sm" onPointerDown={(e) => e.stopPropagation()}>
          <p
            onClick={() => handleView(item)}
            className="flex items-center font-medium text-[#3b82f6]"
          >
            <Eye color="#3b82f6" size={17} className="mr-1" />{" "}
            View
          </p>
          {roleData?.role !== "sub_admin" && (
            <>
              <p
                onClick={() => handleEditView(item.id, index)}
                className="flex items-center font-medium text-[#e43232]"
              >
                <Trash2
                  color="#e43232"
                  size={17}
                  className="mr-1"
                />{" "}
                Delete
              </p>
              <p
                onClick={() => handleEdit(item)}
                className="flex items-center font-medium text-[#000cff]"
              >
                <PenLine
                  color="#000cff"
                  size={17}
                  className="mr-1"
                />{" "}
                Edit
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

function CategoryDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const roleData = JSON.parse(localStorage.getItem("e-learn-data"));

  const imageRef = useRef(null);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    })
  );

  const handleDragEnd = (event) => {
    if (selectStatus === "all") return;
    const { active, over } = event;
    if (over && active.id !== over.id) {
      const oldIndex = resourceData.findIndex((item) => item.id === active.id);
      const newIndex = resourceData.findIndex((item) => item.id === over.id);

      if (oldIndex !== -1 && newIndex !== -1) {
        const draggedItem = resourceData[oldIndex];
        const newOrder = arrayMove(resourceData, oldIndex, newIndex);

        // Optimistically update local positions
        const updatedList = newOrder.map((item, index) => ({
          ...item,
          position_number: index + 1,
        }));
        setResourceData(updatedList);

        const formData = new FormData();
        formData.append("sub_category_id", draggedItem.id);
        formData.append("category_id", id);
        formData.append("title", draggedItem.title || "");
        formData.append("description", draggedItem.description || "");
        formData.append("language_id", draggedItem.language_id);

        const roles = draggedItem.Sub_category_roles?.map((r) => r.role_id) || [];
        if (roles.length) {
          formData.append("role_id", roles.toString());
        }
        formData.append("position_number", newIndex + 1);

        updateSubcategory(formData)
          .then((res) => {
            toast.success("Position updated successfully");
            handleSubCategoryList(false);
          })
          .catch((err) => {
            toast.error(err?.response?.data?.message || "Failed to update position");
            handleSubCategoryList(false);
          });
      }
    }
  };

  const [isAddCategory, setIsAddCategory] = useState(false);
  const [isModalOpens, setModalOpens] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [cropModal, setCropModal] = useState(false);
  const [cropImg, setCropImg] = useState(false);

  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [selectStatus, setSelectStatus] = useState("all");
  const [filterStatus, setFilterStatus] = useState("all");
  const [image, setImage] = useState("");

  const isBlocked = (item) => {
    return item?.isBlock === 1 || item?.isBlock === true || item?.isBlock === '1' || item?.status === 0 || item?.status === '0' || item?.isActive === false || item?.isActive === 0 || item?.isActive === '0';
  };
  const [img, setImg] = useState("");
  const [isIndex, setIsIndex] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [descriptionData, setDescriptionData] = useState("");

  const [totalPage, setTotalPage] = useState();
  const [pageNo, setPageNo] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);

  const [newImge, setNewImge] = useState({});
  const [categoryInfo, setCategoryInfo] = useState({});
  const [formInput, setFormInput] = useState({});

  const [listLanguages, setListLanguages] = useState([]);
  const [brandData, setBrandData] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [isBrandOpen, setIsBrandOpen] = useState(false);
  const [userRoleData, setUserRoleData] = useState([]);
  const [resourceData, setResourceData] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [showRole, setShowRole] = useState([]);
  const [showBrand, setShowBrand] = useState([]);

  let names;
  try {
    const { Name } = location.state;
    names = Name;
  } catch (error) {
    console.log("err");
  }

  const handleLanguages = () => {
    axios
      .get(LIST_LANGUAGES_API)
      .then((res) => {
        const data = res.data.islanguage;
        setListLanguages(data);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response.data.message);
        }
      });
  };

  const handleBrandList = () => {
    getCategoryList()
      .then((res) => {
        const data = res.data.data;
        setBrandData(data);
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err?.response?.data?.message || "Failed to fetch brand list");
        }
      });
  };

  const toggleBrandDropdown = () => {
    setIsBrandOpen((prev) => !prev);
  };

  const handleBrandCheckboxChange = (option) => {
    setSelectedBrands((prevSelected) =>
      prevSelected.includes(option)
        ? prevSelected.filter((item) => item !== option)
        : [...prevSelected, option]
    );
  };

  const handleSelectAllBrands = (e) => {
    if (e.target.checked) {
      const allIds = brandData.map((item) => item.id);
      setSelectedBrands(allIds);
    } else {
      setSelectedBrands([]);
    }
  };

  useEffect(() => {
    handleLanguages();
    handleBrandList();
  }, []);

  const handleUserRoleList = () => {
    listUserRole()
      .then((res) => {
        const data = res.data.data;
        setUserRoleData(data);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response.data.message);
        }
      });
  };

  const handleFile = (e) => {
    setImage(e.target.files[0]);
    let imageData = URL.createObjectURL(e.target.files[0]);
    setImg(imageData);
  };

  const renderPaginationButtonss = () => {
    const maxPagesToShow = 3;
    const buttons = [];
    const startPage = Math.max(1, pageNo - Math.floor(maxPagesToShow / 2));
    const endPage = Math.min(totalPage, startPage + maxPagesToShow - 1);

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={
            i === pageNo
              ? "px-4 py-[7px] mx-1 bg-[#EA5F5F1A] rounded-md text-[#EA5F5F]"
              : "px-4 py-[7px] mx-1 text-[#EA5F5F]"
          }
        >
          {i}
        </button>
      );
    }
    return buttons;
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPage) {
      setPageNo(page);
    }
  };

  const handleSubCategoryList = (showLoader = true) => {
    if (showLoader) {
      setLoader(true);
    }

    let obj = {
      category_id: id,
      page: pageNo,
    };
    if (selectStatus !== "all") {
      obj.language_id = selectStatus;
    }
    if (filterStatus !== "all") {
      obj.isBlock = filterStatus === "inactive" ? 1 : 0;
      obj.status = filterStatus === "inactive" ? 0 : 1;
    }

    getSubcategoryList(obj)
      .then((res) => {
        const data = res.data.data;
        let filteredData = [...data];
        if (filterStatus !== "all") {
          filteredData = filteredData.filter((item) => {
            const blocked = isBlocked(item);
            return filterStatus === "inactive" ? blocked : !blocked;
          });
        }
        const sortedData = filteredData.sort(
          (a, b) => (a.position_number || 0) - (b.position_number || 0)
        );
        setResourceData(sortedData);
        setTotalPage(res.data.totalPages);
        setTotalData(res.data.totalData || 0);
        setLoader(false);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response.data.message);
        }
        setLoader(false);
      });
  };

  useEffect(() => {
    handleSubCategoryList();
  }, [selectStatus, filterStatus, pageNo]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "position_number") {
      if (value !== "") {
        const val = parseInt(value);
        if (isNaN(val) || val < 1 || (totalData && val > totalData)) {
          return;
        }
      }
    }
    setFormInput({ ...formInput, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (!isUpdate) {
      const formData = new FormData();
      formData.append("title", formInput.title);
      formData.append("description", descriptionData);
      formData.append("language_id", formInput.language_id);
      if (selectedOptions.length) {
        formData.append("role_id", selectedOptions.toString());
      }
      if (image) {
        formData.append("subcategory_image", image);
      }
      formData.append("category_id", selectedBrands.toString() || id);

      if (!image) {
        toast.error("Please Select The Image");
        setIsLoading(false);
      } else if (selectedOptions.length === 0) {
        toast.error("Please select user role");
        setIsLoading(false);
      } else if (selectedBrands.length === 0) {
        toast.error("Please select brand");
        setIsLoading(false);
      } else if (!descriptionData) {
        toast.error("Please enter description");
        setIsLoading(false);
      } else {
        formData.append("isBlock", formInput.isBlock !== undefined ? formInput.isBlock : "0");
        formData.append("status", formInput.isBlock === "1" ? "0" : "1");
        addSubcategory(formData)
          .then((res) => {
            toast.success(res.data.message);
            setIsAddCategory(false);
            handleSubCategoryList();
          })
          .catch((err) => {
            if (err.response.status == 401) {
              Cookies.remove("e_learning_token");
              navigate("/login");
            } else {
              toast.error(err.response.data.message);
            }
            setIsLoading(false);
          });
      }
    } else {
      const formData = new FormData();
      formData.append("title", formInput.title);
      formData.append("description", descriptionData);
      formData.append("language_id", formInput.language_id);
      formData.append("category_id", selectedBrands.toString() || id);
      formData.append("sub_category_id", formInput.sub_category_id);
      if (selectedOptions.length) {
        formData.append("role_id", selectedOptions.toString());
      }
      if (image) {
        formData.append("subcategory_image", image);
      }
      if (formInput.position_number !== undefined && formInput.position_number !== null) {
        formData.append("position_number", formInput.position_number);
      }

      if (selectedOptions.length === 0) {
        toast.error("Please select user role");
        setIsLoading(false);
      } else if (selectedBrands.length === 0) {
        toast.error("Please select brand");
        setIsLoading(false);
      } else if (!descriptionData) {
        toast.error("Please enter description");
        setIsLoading(false);
      } else {
        formData.append("isBlock", formInput.isBlock !== undefined ? formInput.isBlock : "0");
        formData.append("status", formInput.isBlock === "1" ? "0" : "1");
        updateSubcategory(formData)
          .then((res) => {
            toast.success(res.data.message);
            setIsAddCategory(false);
            handleSubCategoryList();
          })
          .catch((err) => {
            if (err.response.status == 401) {
              Cookies.remove("e_learning_token");
              navigate("/login");
            } else {
              toast.error(err.response.data.message);
            }
            setIsLoading(false);
          });
      }
    }
  };

  const handleDelete = (e) => {
    e.preventDefault();
    setIsLoading(true);

    deleteSubcategory(categoryId)
      .then((res) => {
        toast.success(res.data.message);
        setIsDelete(false);
        const data = [...resourceData];
        data.splice(isIndex, 1);
        setResourceData(data);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response.data.message);
        }
        setIsLoading(false);
      });
  };

  const handleEdit = (data) => {
    setIsLoading(false);
    setSelectedOptions([]);
    const images = data?.Sub_category_images;
    const isEditBlocked = data.isBlock === 1 || data.isBlock === true || data.isBlock === '1' || data.status === 0 || data.status === '0' || data.isActive === false || data.isActive === 0 || data.isActive === '0';
    let obj = {
      title: data.title,
      description: data.description,
      sub_category_id: images[0]?.sub_category_id,
      category_id: data.category_id,
      subcategory_image: images[0]?.subcategory_image,
      language_id: data.language_id,
      role_id: data.role_id,
      position_number: data.position_number,
      isBlock: isEditBlocked ? "1" : "0",
    };
    setDescriptionData(data.description);
    setFormInput(obj);
    setIsUpdate(true);
    setIsAddCategory(true);
    handleUserRoleList();
    setIsOpen(false);
    setIsBrandOpen(false);
    setImage("");
    setImg("");

    for (let i = 0; i < data.Sub_category_roles.length; i++) {
      const main = data.Sub_category_roles[i].role_id;
      setSelectedOptions((pre) => [...pre, main]);
    }

    if (data.categories && Array.isArray(data.categories)) {
      const ids = data.categories.map((c) => c.id);
      setSelectedBrands(ids);
    } else if (data.category_id) {
      if (typeof data.category_id === "string") {
        const ids = data.category_id.split(",").map(Number);
        setSelectedBrands(ids);
      } else if (typeof data.category_id === "number") {
        setSelectedBrands([data.category_id]);
      } else {
        setSelectedBrands([Number(data.category_id)]);
      }
    } else {
      setSelectedBrands([]);
    }
  };

  const handleView = (data) => {
    const image = data?.Sub_category_images;
    let obj = {
      subcategory_image: image[0]?.subcategory_image,
      title: data.title,
      description: data.description,
    };
    setCategoryInfo(obj);
    setModalOpens(true);
    setIsLoading(false);
    const roles =
      data?.Sub_category_roles?.map((role) => role?.User_Role?.role_name) || [];
    setShowRole(roles);
    const brands = data?.categories?.map((c) => c.category_name) || [];
    setShowBrand(brands);
  };

  const handleOpen = () => {
    setIsAddCategory(true);
    setFormInput({ isBlock: "0" });
    setImg("");
    setIsUpdate(false);
    handleUserRoleList();
    setIsOpen(false);
    setIsBrandOpen(false);
    setSelectedOptions([]);
    setSelectedBrands([]);
    setDescriptionData("");
    setIsLoading(false);
  };

  const handleBlock = (item, index) => {
    const currentBlocked = item.isBlock === 1 || item.isBlock === true || item.isBlock === '1' || item.status === 0 || item.status === '0' || item.isActive === false || item.isActive === 0 || item.isActive === '0';
    const newBlockedVal = currentBlocked ? 0 : 1;
    const newStatusVal = currentBlocked ? "1" : "0";

    changeSubcategoryStatus({ sub_category_id: item.id })
      .then((res) => {
        toast.success(res.data.message);
        setResourceData((prevData) => {
          const newData = [...prevData];
          const updatedItem = { ...newData[index] };
          updatedItem.isBlock = newBlockedVal;
          updatedItem.status = newStatusVal;
          if (updatedItem.isActive !== undefined) {
            updatedItem.isActive = currentBlocked ? true : false;
          }
          newData[index] = updatedItem;
          return newData;
        });
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response?.data?.message || "Failed to change status");
        }
      });
  };

  const handleCheckboxChange = (option) => {
    setSelectedOptions((prevSelected) =>
      prevSelected.includes(option)
        ? prevSelected.filter((item) => item !== option)
        : [...prevSelected, option]
    );
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = userRoleData.map((item) => item.id);
      setSelectedOptions(allIds);
    } else {
      setSelectedOptions([]);
    }
  };

  const toggleDropdown = () => {
    if (!isOpen) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  };

  const HtmlContent = ({ htmlString }) => {
    const sanitizedHtml = DOMPurify.sanitize(htmlString);
    const style = `
      ol {
        margin: 0;
        padding: 0;
        list-style-type: decimal; /* Numbering */
        padding-left: 20px; /* Adjust left padding as needed */
      }
      ul {
        margin: 0;
        padding: 0;
        list-style-type: disc; /* Bullets */
        padding-left: 20px; /* Adjust left padding as needed */
      }
      li {
        margin: 0;
        padding: 0;
        line-height: 1.5;
      } 
      a {
        color: blue;
      }
    `;

    return (
      <div
        dangerouslySetInnerHTML={{
          __html: `<style>${style}</style>${sanitizedHtml}`,
        }}
      />
    );
  };

  HtmlContent.propTypes = {
    htmlString: PropTypes.string.isRequired,
  };

  const handleEditView = (id, index) => {
    setIsDelete(true);
    setCategoryId(id);
    setIsIndex(index);
    setIsLoading(false);
  };

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const getCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        img ? img : IMG_URL + newImge.category_image,
        croppedAreaPixels
      );
      console.log("Cropped Image: ", croppedImage);
    } catch (e) {
      console.error("Crop failed:", e);
    }
  }, [croppedAreaPixels, img, IMG_URL, newImge]);

  const getCroppedImg = (imageSrc, croppedAreaPixels) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = imageSrc;
      image.setAttribute("crossOrigin", "anonymous");

      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = croppedAreaPixels.width;
        canvas.height = croppedAreaPixels.height;

        ctx.drawImage(
          image,
          croppedAreaPixels.x,
          croppedAreaPixels.y,
          croppedAreaPixels.width,
          croppedAreaPixels.height,
          0,
          0,
          croppedAreaPixels.width,
          croppedAreaPixels.height
        );

        const base64Image = canvas.toDataURL("image/jpeg");
        setImg(base64Image);

        fetch(base64Image)
          .then((res) => res.blob())
          .then((blob) => {
            const file = new File([blob], "cropped-image.jpg", {
              type: "image/jpeg",
            });
            setImage(file);
          });
      };

      image.onerror = (error) => {
        reject(error);
      };
    });
  };

  return (
    <div className="md:m-4 m-1 fontNew">
      <div className="flex sm:flex-nowrap flex-wrap justify-between mb-7">
        <div className="flex items-center cursor-pointer mb-4">
          <img
            src={back}
            onClick={() => {
              navigate("/brand");
            }}
            className="w-4"
            alt=""
          />
          <p
            onClick={() => {
              navigate("/brand");
            }}
            className="text-base font-medium ms-3 p-0"
          >
            Go back
          </p>
        </div>
        <div className="flex sm:flex-nowrap flex-wrap-reverse items-center justify-end sm:w-auto w-full">
          <div className="xl:w-40 sm:w-36 w-full sm:me-3 me-0">
            <FormSelect
              id="status"
              value={filterStatus}
              onChange={(e) => {
                setFilterStatus(e.target.value);
                setPageNo(1);
              }}
              className="sm:mb-0 mb-3 ps-5 pl-0 pb-0 pt-0 select-arrow-hidden text-sm rounded-[8px] font-medium xl:w-40 sm:w-36 w-full h-10 outline-none"
            >
              <option value="all">All Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </FormSelect>
          </div>
          <div className="xl:w-40 sm:w-36 w-full sm:me-3 me-0">
            <FormSelect
              id="category"
              value={selectStatus}
              onChange={(e) => {
                setSelectStatus(e.target.value);
                setPageNo(1);
              }}
              className="sm:mb-0 mb-3 ps-5 pl-0 pb-0 pt-0 select-arrow-hidden text-sm rounded-[8px] font-medium xl:w-40 sm:w-36 w-full h-10 outline-none"
            >
              <option value="all">All Languages</option>
              {listLanguages.map((item, index) => {
                return (
                  <option key={index} value={item.id}>
                    {item.Language_name}
                  </option>
                );
              })}
            </FormSelect>
          </div>
          {roleData?.role !== "sub_admin" && (
            <div className="sm:w-auto w-full sm:block flex justify-end">
              <button
                onClick={handleOpen}
                className="bg-[#e29c29] text-white flex items-center py-2 px-3 sm:mb-0 mb-3 rounded-lg whitespace-nowrap"
              >
                <img src={add} className="w-6 mr-2" alt="" />
                Add Sub Category
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="my-4 flex justify-center">
        <h4 className="text-2xl font-medium capitalize tracking-wider font-medium">
          {names || ""}
        </h4>
      </div>

      <div className="grid grid-cols-12 2xl:gap-10 xl:gap-5 gap-4">
        {loader ? (
          <div className="flex justify-center items-center col-span-12 h-[70vh]">
            <Bars
              height="35"
              width="35"
              color="#e29c29"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        ) : (
          <>
            {resourceData.length === 0 ? (
              <div className="col-span-12 h-[50vh] justify-center flex items-center">
                <img src={nodata} className="w-28" alt="No data" />
              </div>
            ) : (
              <>
                <DndContext
                  sensors={sensors}
                  collisionDetection={closestCenter}
                  onDragEnd={handleDragEnd}
                >
                  <SortableContext
                    items={resourceData.map((item) => item.id)}
                    strategy={rectSortingStrategy}
                  >
                    {resourceData.map((item, index) => (
                      <SortableSubcategoryItem
                        key={item.id}
                        item={item}
                        index={index}
                        selectStatus={selectStatus}
                        roleData={roleData}
                        handleView={handleView}
                        handleEditView={handleEditView}
                        handleEdit={handleEdit}
                        handleBlock={handleBlock}
                        IMG_URL={IMG_URL}
                      />
                    ))}
                  </SortableContext>
                </DndContext>
                <div className="col-span-12 flex flex-wrap items-center sm:justify-end justify-center py-4 sm:px-8 px-0 bg-white rounded-lg">
                  <div className="flex items-center cursor-pointer">
                    <p
                      onClick={() => handlePageChange(pageNo - 1)}
                      disabled={pageNo === 1}
                    >
                      Previous
                    </p>
                    <div className="flex items-center mx-6">
                      {renderPaginationButtonss()}
                    </div>
                    <p
                      onClick={() => handlePageChange(pageNo + 1)}
                      disabled={pageNo === totalPage}
                    >
                      Next
                    </p>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>

      <Dialog
        open={isAddCategory}
        onClose={() => setIsAddCategory(false)}
        size="xl"
      >
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="p-4 sm:w-auto w-[330px] md:h-[700px] h-[500px] overflow-auto fontNew">
              <h4 className="text-lg font-semibold mb-2">
                {isUpdate ? "Update" : "Add"} Sub Category
              </h4>
              <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-12 ">
                  <div className="col-span-12 flex items-center mx-2 my-3">
                    <div className="w-full p-5 border-2 border-dashed rounded-md shadow-sm border-slate-300/60 dark:border-darkmode-400">
                      <div className="relative cursor-pointer h-52 w-full image-fit flex justify-center items-start">
                        {img || formInput.subcategory_image ? (
                          <div className="flex">
                            <img
                              className="rounded-md w-auto h-52"
                              alt="Midone - HTML Admin Template"
                              src={
                                img
                                  ? img
                                  : formInput.subcategory_image
                                    ? IMG_URL + formInput.subcategory_image
                                    : noImage
                              }
                            />
                            {img ? (
                              <div
                                className="w-6 h-6"
                                onClick={() => setImg("")}
                              >
                                <img
                                  src={close}
                                  className="w-6 h-6 -ms-4 -mt-2 relative z-99"
                                  alt=""
                                />
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        ) : (
                          <p className="flex justify-center items-center h-52">
                            Image Not Found{" "}
                          </p>
                        )}
                      </div>
                      <div className="flex justify-center items-center mt-4">
                        <div className="relative flex items-center justify-center cursor-pointer">
                          <Upload className="text-blue-600" size={18} />
                          <h4 className="mr-1 text-blue-600 ml-2 sm:text-base text-sm">
                            Upload Subcategory Image
                          </h4>{" "}
                          <input
                            id="horizontal-form-1"
                            type="file"
                            className="absolute top-0 left-0 w-full h-full opacity-0"
                            accept="image/*"
                            onChange={handleFile}
                          />
                        </div>
                        <div>
                          {img && !cropImg ? (
                            <b
                              className="cursor-pointer underline sm:text-base text-sm"
                              onClick={(e) => setCropModal(true)}
                            >
                              Crop Image
                            </b>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-3">
                    <h4 className="text-sm font-medium mb-3">
                      Select Language
                    </h4>
                    <select
                      name="language_id"
                      required
                      onChange={handleChange}
                      value={formInput.language_id}
                      className="select-arrow-hidden w-full outline-[#e1c595] border-2 px-4 py-3 rounded-md"
                    >
                      <option label="Select Language"></option>
                      {listLanguages.map((item, index) => {
                        return (
                          <option key={index} value={item.id}>
                            {item.Language_name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-3">
                    <h4 className="text-sm font-medium mb-3">
                      Select Brand
                    </h4>
                    <div className="multi-select-dropdown bg-white rounded px-4 py-3 border-2 w-full outline-2 outline-[#ead5fd]">
                      <div
                        className="flex justify-between cursor-pointer"
                        onClick={toggleBrandDropdown}
                      >
                        <span>{"Select Brand"}</span>
                        <button type="button">
                          {isBrandOpen ? (
                            <ChevronUp className="text-[#000000]" />
                          ) : (
                            <ChevronDown className="text-[#000000]" />
                          )}
                        </button>
                      </div>

                      {isBrandOpen && (
                        <div className="dropdown-menu w-full rounded-lg">
                          <label className="flex items-center space-x-2 border-b pb-2 mb-2">
                            <input
                              type="checkbox"
                              className="absolute right-0 setOptionCheckbox"
                              checked={
                                selectedBrands.length === brandData.length &&
                                brandData.length > 0
                              }
                              onChange={handleSelectAllBrands}
                            />
                            Select All
                          </label>
                          {brandData.map((item, index) => (
                            <label
                              key={index}
                              className="flex items-center space-x-2"
                            >
                              <input
                                type="checkbox"
                                className="absolute right-0 setOptionCheckbox"
                                checked={selectedBrands.includes(item.id)}
                                onChange={() => handleBrandCheckboxChange(item.id)}
                              />
                              {item.category_name}
                            </label>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">
                      Select User Role
                    </h4>
                    <div className="multi-select-dropdown bg-white rounded px-4 py-3 border-2 w-full outline-2 outline-[#ead5fd]">
                      <div
                        className="flex justify-between cursor-pointer"
                        onClick={toggleDropdown}
                      >
                        <span>{"Select Multiple User Role"}</span>
                        <button type="button">
                          {isOpen ? (
                            <ChevronUp className="text-[#000000]" />
                          ) : (
                            <ChevronDown className="text-[#000000]" />
                          )}
                        </button>
                      </div>

                      {isOpen && (
                        <div className="dropdown-menu w-full rounded-lg">
                          <label className="flex items-center space-x-2 border-b pb-2 mb-2">
                            <input
                              type="checkbox"
                              className="absolute right-0 setOptionCheckbox"
                              checked={
                                selectedOptions.length ===
                                userRoleData.length && userRoleData.length > 0
                              }
                              onChange={handleSelectAll}
                            />
                            Select All
                          </label>
                          {userRoleData.map((item, index) => (
                            <label
                              key={index}
                              className="flex items-center space-x-2"
                            >
                              <input
                                type="checkbox"
                                className="absolute right-0 setOptionCheckbox"
                                checked={selectedOptions.includes(item.id)}
                                onChange={() => handleCheckboxChange(item.id)}
                              />
                              {item.role_name}
                            </label>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-3">
                    <h4 className="text-sm font-medium mb-3">
                      Subcategory Name
                    </h4>
                    <input
                      type="text"
                      name="title"
                      value={formInput.title || ""}
                      required
                      onChange={handleChange}
                      className="border-2 px-4 py-3 rounded-md w-full outline-[#e1c595]"
                      placeholder="Enter"
                    />
                  </div>

                  {isUpdate && (
                    <div className="col-span-12 md:mx-2 mx-0 my-3">
                      <h4 className="text-sm font-medium mb-3">
                        Position Number
                      </h4>
                      <input
                        type="number"
                        min="1"
                        max={totalData || undefined}
                        name="position_number"
                        value={formInput.position_number || ""}
                        onChange={handleChange}
                        onKeyDown={(e) => {
                          if (
                            e.key === "-" ||
                            e.key === "+" ||
                            e.key === "." ||
                            e.key === "e" ||
                            e.key === "E" ||
                            e.key === "ArrowUp" ||
                            e.key === "ArrowDown"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onWheel={(e) => e.target.blur()}
                        onPaste={(e) => {
                          const paste = e.clipboardData.getData("text");
                          if (/[^0-9]/.test(paste)) {
                            e.preventDefault();
                          }
                        }}
                        autoComplete="off"
                        className="border-2 px-4 py-3 rounded-md w-full outline-[#e1c595]"
                        style={{ appearance: "textfield", MozAppearance: "textfield" }}
                        placeholder="Enter Position Number"
                      />
                    </div>
                  )}
                  <div className="col-span-12 md:mx-2 mx-0 my-3">
                    <h4 className="text-sm font-medium mb-3">
                      Subcategory Description
                    </h4>
                    <SunEditor
                      setContents={descriptionData || ""}
                      onChange={setDescriptionData}
                      height="280px"
                      setOptions={{
                        buttonList: [
                          ["undo", "redo"],
                          ["fontSize"],
                          ["bold", "underline", "italic"],
                          ["fontColor", "hiliteColor"],
                          ["align", "list"],
                          ["link", "image"],
                        ],
                      }}
                      name="my-editor"
                      required
                    />
                  </div>
                </div>
                <div className="mt-6 flex justify-end">
                  <button
                    type="button"
                    onClick={() => setIsAddCategory(false)}
                    className="bg-[#EF5F5F] py-2 px-7 text-white rounded-lg mr-5"
                  >
                    Close
                  </button>
                  <button
                    disabled={isLoading}
                    className="bg-[#00987C] h-[50px] sm:w-34 w-30 rounded-lg text-white"
                    onClick={() => setIsDelete(false)}
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      `${isUpdate ? "Update" : "Save"}`
                    )}
                  </button>
                </div>
              </form>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog
        open={isModalOpens}
        onClose={() => setModalOpens(false)}
        size="xl"
      >
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white fontNew">
            <div className="p-5 sm:w-auto w-[330px] md:h-[700px] h-[500px] overflow-auto">
              <div className="mb-4 flex justify-between">
                <h4 className="text-lg font-medium">Category Details</h4>
                <CircleX
                  color="gray"
                  size={28}
                  onClick={() => setModalOpens(false)}
                  className="cursor-pointer"
                />
              </div>
              <div className="flex justify-center mt-4">
                <img
                  src={
                    categoryInfo.subcategory_image
                      ? IMG_URL + categoryInfo.subcategory_image
                      : noImage
                  }
                  className="w-auto h-52 object-cover rounded-md"
                  alt=""
                />
              </div>
              <div className="my-3">
                <h4>Title :</h4>
                <h3 className="text-lg break-words font-medium">
                  {categoryInfo.title || ""}
                </h3>
              </div>
              <div className="my-3 flex flex-wrap">
                <span className="font-medium">User Role : </span>{" "}
                <span>{showRole.toString()}</span>
              </div>
              <div className="my-3 flex flex-wrap">
                <span className="font-medium">Selected Brand : </span>{" "}
                <span>{showBrand.join(", ")}</span>
              </div>
              <div>
                <h4>Description :</h4>
                <p>
                  <HtmlContent htmlString={categoryInfo.description || ""} />
                </p>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog open={isDelete} onClose={() => setIsDelete(false)} size="2xl">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="flex justify-center text-center my-4 sm:px-16 px-4 fontNew">
              <div>
                <h4 className="text-xl font-semibold text-black mt-6">
                  Delete Sub Category?
                </h4>
                <p className="text-sm text-gray-500 my-3">
                  Are you sure you want to delete this Sub Category?
                </p>
                <div className="mt-13 flex items-center mb-5">
                  <button
                    className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                    onClick={() => setIsDelete(false)}
                  >
                    Close
                  </button>
                  <button
                    disabled={isLoading}
                    className="bg-[#e29c29] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                    onClick={handleDelete}
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      "Yes, Delete"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog
        open={cropModal}
        onClose={() => setCropModal(false)}
        initialFocus={imageRef}
        size="lg"
      >
        <Dialog.Panel className=" w-full mx-auto bg-white px-5 pt-2">
          <Dialog.Title className="flex justify-between text-lg font-medium">
            <h4>Crop Image</h4>
            <CircleX
              color="gray"
              size={28}
              onClick={() => setCropModal(false)}
              className="cursor-pointer"
            />
          </Dialog.Title>
          <Dialog.Description className="mt-4">
            <div className="relative w-full h-[400px]">
              <Cropper
                image={img ? img : IMG_URL + newImge.category_image}
                crop={crop}
                zoom={zoom}
                aspect={297 / 210}
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={onCropComplete}
              />
            </div>
          </Dialog.Description>
          <Dialog.Footer className="flex justify-end mt-4">
            <button
              className="w-24 bg-[#00987C] px-4 py-2 rounded-lg text-white"
              type="button"
              onClick={() => {
                getCroppedImage();
                setCropModal(false);
              }}
            >
              Submit
            </button>
          </Dialog.Footer>
        </Dialog.Panel>
      </Dialog>
    </div>
  );
}

export default CategoryDetails;
